export enum Step {
  InputRegistrationNumber,
  LoadingCompanyInfo,
  InputCustomCompanyName,
  ConfirmCompanyInfo,
  InputPhoneNumber,
  SendingPhoneNumberVerificationKey,
  InputPhoneNumberVerificationKey,
  CheckingPhoneNumberVerificationKey,
  InputPassword,
  RepeatPassword,
  BeforeReadingTerm,
  AgreeTerm,
  AllDone,
}

export type gtagEvent =
  | "change_step"
  | "get_company_info"
  | "register_account"
  | "click_button"

export type Category = "incheon_registration"

export type FocusItem =
  | "registrationNumber"
  | "companyName"
  | "phone"
  | "verificationCode"
  | "password"
  | "repeatingPassword"
  | "readTerm"
  | "register"

export type CompanyNameStatus =
  | "AUTOMATIC"
  | "CUSTOM"
  | "CUSTOM_CONFIRMED"
  | "AUTOMATIC_CONFIRMED"
  | undefined
